import { DESTINATION_TYPES } from "@/react/features/support-tools/extensions/constants";
import React from "react";
import {
  StringCell,
  ValidationWrapper,
} from "@/react/components/table/components";
import FullWidthDiv from "@/react/features/styled/FullWidthDiv";
import { useDestinationCell } from "@/react/features/support-tools/extensions/forwarding-rules/cells/useDestinationCell";
import { Tag } from "@/react/styled";

export const DestinationCell = (rule) => (props) => {
  const { errors, destinationType, value } = useDestinationCell(props, rule);

  if (destinationType === DESTINATION_TYPES.VOICEMAIL)
    return (
      <FullWidthDiv>
        <ValidationWrapper errors={errors}>{value || 555}</ValidationWrapper>
      </FullWidthDiv>
    );

  if (
    [DESTINATION_TYPES.AUTO_ATTENDANT, DESTINATION_TYPES.EXTENSION].includes(
      destinationType
    )
  )
    return (
      <ValidationWrapper errors={errors}>
        <Tag hasError={errors?.length > 0}>{value}</Tag>
      </ValidationWrapper>
    );

  if (destinationType === DESTINATION_TYPES.EXTERNAL_NUMBER)
    return <StringCell {...props} />;

  if (destinationType === DESTINATION_TYPES.DROP_CALL) return null;

  if (value) {
    return value;
  }
  return "No destination type provided";
};
